import React from "react";
import {
    LoadCanvasTemplate,
    //@ts-ignore
} from "react-simple-captcha";
import { Modal } from "react-bootstrap";
import "./closeFinancialCycle.scss";
import { CloseFinancialModalProps } from "./CloseFinancial.props";
import { Button } from "components";
import { ReactComponent as WarningIcon } from "assets/icons/circle_warning_fill.svg";

const CloseFinancialCycleModal: React.FC<CloseFinancialModalProps> = ({
    title,
    onConfirm,
    onToggleShowModal,
    showModal,
    captchaMatchError,
}) => {
    return (
        <Modal
            data-testid="CloseFinancialModal"
            show={showModal}
            onHide={() => onToggleShowModal(false)}
            className="rtl confirm-close-cycle"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body data-testid="modalShowTitle">
                آیا از بستن <b>{title}</b> اطمینان دارید؟
                <div className="captcha-wrapper">
                    <LoadCanvasTemplate />
                    <div className="captcha-input">
                        <input
                            placeholder="Enter Captcha Value"
                            id="user_captcha_input"
                            name="user_captcha_input"
                            type="text"
                        />
                    </div>
                </div>
                {captchaMatchError && (
                    <div className="captcha-error">
                        <span
                            className="captcha-error-text"
                            data-testid="captcha-error"
                        >
                            {captchaMatchError}
                        </span>
                        <WarningIcon />
                    </div>
                )}
                <Button
                    btnText="تایید"
                    className="solid is-green"
                    handleClick={onConfirm}
                />
                <Button
                    btnText="انصراف"
                    className="bordered is-green"
                    handleClick={() => onToggleShowModal(false)}
                />
            </Modal.Body>
        </Modal>
    );
};

export default CloseFinancialCycleModal;
